module.exports = __webpack_public_path__ + "img/home1.b58db44a.png";